declare global {
  interface Window {
    __gcse: {
      callback: () => void
    }
  }
}

export const createSearchForm = (apiKey: string) => {
  if (!document) {
    return
  }
  const gcse = document.createElement('script')
  gcse.type = 'text/javascript'
  gcse.async = true
  gcse.src = `https://cse.google.com/cse.js?cx=${apiKey}`
  const s = document.getElementsByTagName('script')[0] as HTMLScriptElement
  if (s != null) {
    if (s.parentNode != null) {
      s.parentNode.insertBefore(gcse, s)
    }
  }
}
